function GetCurrentQuarter (date) {
  return Math.floor(date.getMonth() / 3)
}

function GetMonthRelativeDate (date, count) {
  var newDate = date.setMonth(date.getMonth() + count)
  return new Date(newDate)
}

function GetDaysRelativeDate (date, count) {
  var newDate = date.setDate(date.getDate() + count)
  return new Date(newDate)
}

function GetFirtDayOfWeek (date) {
  var day = date.getDay()
  var diff = date.getDate() - day
  return new Date(date.setDate(diff))
}

function GetEndDay (date) {
  return new Date(date.setHours(23, 59, 59, 999))
}

function GetStartQuarter (date) {
  return new Date(date.getFullYear(), GetCurrentQuarter(date) * 3, 1)
}

function GetEndQuarter (date) {
  var lastQuarterMouth = new Date(
    date.getFullYear(),
    GetCurrentQuarter(date) * 3 + 3,
    0
  )
  return GetEndDay(lastQuarterMouth)
}

function GetLast30thDay (date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}
function GetStartMonth (date) {
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

function GetEndMonth (date) {
  var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  return GetEndDay(lastDayOfMonth)
}

function GetStartYear (date) {
  return new Date(date.getFullYear(), 0, 1)
}

function GetEndYear (date) {
  var lastDayOfYear = new Date(date.getFullYear(), 12, 0)
  return GetEndDay(lastDayOfYear)
}

function GetStartWeek (date) {
  var firstDayOfWeek = GetFirtDayOfWeek(date)
  return new Date(
    firstDayOfWeek.getFullYear(),
    firstDayOfWeek.getMonth(),
    firstDayOfWeek.getDate()
  )
}

function GetEndWeek (date) {
  var startDayOfWeek = GetStartWeek(date)
  var lastDayOfWeek = new Date(GetDaysRelativeDate(startDayOfWeek, 6))
  return GetEndDay(lastDayOfWeek)
}

var startLast30Days = GetLast30thDay(GetDaysRelativeDate(new Date(), -30))
var endLast30Days = GetEndDay(new Date())
var startThisQuarter = GetStartQuarter(new Date())
var endThisQuarter = GetEndQuarter(new Date())
var startLastQuarter = GetStartQuarter(GetMonthRelativeDate(new Date(), -3))
var endLastQuarter = GetEndQuarter(GetMonthRelativeDate(new Date(), -3))

var startThisMonth = GetStartMonth(new Date())
var endThisMonth = GetEndMonth(new Date())
var startLastMonth = GetStartMonth(GetMonthRelativeDate(new Date(), -1))
var endLastMonth = GetEndMonth(GetMonthRelativeDate(new Date(), -1))

var startThisYear = GetStartYear(new Date())
var endThisYear = GetEndYear(new Date())
var startLastYear = GetStartYear(GetMonthRelativeDate(new Date(), -12))
var endLastYear = GetEndYear(GetMonthRelativeDate(new Date(), -12))

var startThisWeek = GetStartWeek(new Date())
var endThisWeek = GetEndWeek(new Date())
var startLastWeek = GetStartWeek(GetDaysRelativeDate(new Date(), -7))
var endLastWeek = GetEndWeek(GetDaysRelativeDate(new Date(), -7))

let getDateFilter = function (propertyName) {
  return [
    {
      text: 'This Quarter',
      value: [
        [propertyName, '>=', startThisQuarter],
        'and',
        [propertyName, '<=', endThisQuarter]
      ]
    },
    {
      text: 'Last Quarter',
      value: [
        [propertyName, '>=', startLastQuarter],
        'and',
        [propertyName, '<=', endLastQuarter]
      ]
    },
    {
      text: 'This Month',
      value: [
        [propertyName, '>=', startThisMonth],
        'and',
        [propertyName, '<=', endThisMonth]
      ]
    },
    {
      text: 'Last Month',
      value: [
        [propertyName, '>=', startLastMonth],
        'and',
        [propertyName, '<=', endLastMonth]
      ]
    },
    {
      text: 'This Year',
      value: [
        [propertyName, '>=', startThisYear],
        'and',
        [propertyName, '<=', endThisYear]
      ]
    },
    {
      text: 'Last Year',
      value: [
        [propertyName, '>=', startLastYear],
        'and',
        [propertyName, '<=', endLastYear]
      ]
    },
    {
      text: 'This Week',
      value: [
        [propertyName, '>=', startThisWeek],
        'and',
        [propertyName, '<=', endThisWeek]
      ]
    },
    {
      text: 'Last Week',
      value: [
        [propertyName, '>=', startLastWeek],
        'and',
        [propertyName, '<=', endLastWeek]
      ]
    }
  ]
}

const ranges = {
  'Last 30 Days': [startLast30Days, endLast30Days],
  'This Month': [startThisMonth, endThisMonth],
  'Last Month': [startLastMonth, endLastMonth],
  'This Quarter': [startThisQuarter, endThisQuarter],
  'Last Quarter': [startLastQuarter, endLastQuarter],
  'This Year': [startThisYear, endThisYear],
  'Last Year': [startLastYear, endLastYear]
}

export {
  getDateFilter,
  startThisQuarter,
  endThisQuarter,
  startLastQuarter,
  endLastQuarter,
  startThisMonth,
  endThisMonth,
  startLastMonth,
  endLastMonth,
  startThisYear,
  endThisYear,
  startLastYear,
  endLastYear,
  startThisWeek,
  endThisWeek,
  startLastWeek,
  endLastWeek,
  ranges
}
